import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/api/client';
import { ListChecks } from 'lucide-react';
import { toast } from 'sonner';

const STATUS_OPTIONS = ['Accepted', 'In Progress', 'Completed'];

export default function Tasks() {
  const qc = useQueryClient();
  const { data: tasks = [] } = useQuery({ queryKey: ['my-tasks-full'], queryFn: async () => (await api.get('/member/tasks')).data });
  const mut = useMutation({
    mutationFn: async ({ id, status }) => (await api.put(`/member/tasks/${id}/status`, { status })).data,
    onSuccess: () => { toast.success('Status updated'); qc.invalidateQueries({ queryKey: ['my-tasks-full'] }); },
  });

  return (
    <div className="space-y-6">
      <div className="card-moj p-6">
        <h1 className="font-serif text-2xl text-moj-purple-deep flex items-center gap-2 mb-2"><ListChecks/> My Tasks</h1>
        <p className="text-sm text-moj-charcoal/70">Tasks assigned to you by team leaders, admin or pastor.</p>
      </div>
      {tasks.length === 0 && <div className="card-moj p-10 text-center text-moj-charcoal/60">No tasks assigned yet.</div>}
      <div className="space-y-3">
        {tasks.map((t) => (
          <div key={t.id} className="card-moj p-5" data-testid={`task-${t.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="flex-1">
                <div className="font-serif text-lg text-moj-purple-deep">{t.title}</div>
                <p className="text-sm text-moj-charcoal/80 mt-1">{t.description}</p>
                {t.notes && <p className="text-xs italic text-moj-charcoal/60 mt-2">Notes: {t.notes}</p>}
                <div className="flex flex-wrap gap-3 text-xs text-moj-charcoal/70 mt-2">
                  <span><strong>Team:</strong> {t.department}</span>
                  <span><strong>Assigned:</strong> {t.assigned_date}</span>
                  <span><strong>Due:</strong> {t.due_date}</span>
                  <span><strong>By:</strong> {t.assigned_by_name}</span>
                </div>
              </div>
              <div className="flex flex-col items-end gap-2">
                <span className="text-xs font-bold px-3 py-1 rounded-full bg-moj-gold/20 text-moj-purple-deep">{t.status}</span>
                {t.status !== 'Completed' && t.status !== 'Cancelled' && (
                  <select value={t.status} onChange={(e) => mut.mutate({ id: t.id, status: e.target.value })} className="input-moj text-xs py-1 px-2" data-testid={`task-status-${t.id}`}>
                    {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
